"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProperty = void 0;
const react_1 = require("react");
const usePropertyPath_1 = require("../usePropertyPath/usePropertyPath");
const utils_1 = require("../../utils");
const usePropertySchema_1 = require("../usePropertySchema/usePropertySchema");
const useFormData_1 = require("../useFormData/useFormData");
/**
 * Given a schema, form data and a property path will return the
 * schema and value for the requested property.
 */
const useProperty = (path) => {
    const { rootSchema, formData, onChange, disabled } = (0, useFormData_1.useFormData)();
    const { pathSegments, error: propertyPathError } = (0, usePropertyPath_1.usePropertyPath)(path);
    const { schema, required, error: propertySchemaError } = (0, usePropertySchema_1.usePropertySchema)(rootSchema, pathSegments);
    const value = (0, react_1.useMemo)(() => pathSegments && (0, utils_1.getPropertyValue)(pathSegments, formData), [pathSegments, formData]);
    const validationErrors = (0, react_1.useMemo)(() => {
        if (!schema) {
            // schema couldn't be resolved, property path is invalid or conditions in schema resulted in the property
            // not being available.
            return [];
        }
        const { errors } = utils_1.defaultValidator.validateFormData(value, schema);
        return errors;
    }, [value, schema]);
    const setValue = (0, react_1.useCallback)((value) => {
        onChange({
            formData: (0, utils_1.setPropertyValue)(pathSegments, formData, value),
        });
    }, [onChange, pathSegments, formData]);
    if (propertyPathError || propertySchemaError) {
        return {
            error: propertyPathError || propertySchemaError,
        };
    }
    return {
        disabled,
        schema,
        required,
        value: value,
        setValue,
        validation: {
            isValid: validationErrors.length === 0,
            errors: validationErrors,
        },
    };
};
exports.useProperty = useProperty;
//# sourceMappingURL=useProperty.js.map